import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum NavSection {
  Content = 'CONTENT',
  Teams = 'TEAMS',
  Users = 'USERS',
  Reports = 'REPORTS',
  Search = 'SEARCH',
}

interface IDrillDown {
  rootId: string;
  breadcrumb: string;
}

interface INavPanelState {
  pinned: boolean;
  panelOpen: boolean;
  pinnedSection: NavSection | null;
  searchQuery: string;
  drillDown: {
    [NavSection.Content]: IDrillDown | null;
    [NavSection.Teams]: IDrillDown | null;
  };
}

const initialState: INavPanelState = {
  pinned: false,
  panelOpen: false,
  pinnedSection: null,
  searchQuery: '',
  drillDown: {
    [NavSection.Content]: null,
    [NavSection.Teams]: null,
  },
};

export const navPanelSlice = createSlice({
  name: 'navPanel',
  initialState,
  reducers: {
    pinPanel(state, action: PayloadAction<NavSection>) {
      state.pinned = true;
      state.pinnedSection = action.payload;
      if (action.payload !== NavSection.Search) {
        state.searchQuery = '';
      }
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },
    unpinPanel(state) {
      state.pinned = false;
      state.pinnedSection = null;
    },
    setDrillDown(
      state,
      action: PayloadAction<{
        section: NavSection.Content | NavSection.Teams;
        drillDown: IDrillDown;
      }>,
    ) {
      state.drillDown[action.payload.section] = action.payload.drillDown;
    },
    clearDrillDown(state, action: PayloadAction<NavSection.Content | NavSection.Teams>) {
      state.drillDown[action.payload] = null;
    },
    setPanelOpen(state, action: PayloadAction<boolean>) {
      state.panelOpen = action.payload;
    },
  },
});

export const { pinPanel, unpinPanel, setDrillDown, clearDrillDown, setPanelOpen, setSearchQuery } =
  navPanelSlice.actions;
